import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';
export default function free3_3Box(props) {
  // 모듈러 링크 리액트 hook
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    let contentId;
    let contentTitle;


    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '상단영역_자유형(3개)',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: '',
      },
    });
  };

  return (

    <div className="swiper-slide slide-slide">
      <div className="swiper-cont">
        {/* <!-- 자유형 : type1 : 포토 기본 --> */}
        <div className={`spotModuleWrap_ContentPhoto ${props.data.title == '' || props.data.title == null ? 'spotModuleWrap_freeType3' : ''}`}>
          {/* <a href={props.data.link_url} className="spotModuleLink">
              <span className="spotModuleImage_w">
                <img src="https://via.placeholder.com/335x256" className="spotModuleImg" alt={props.data.m_img_attr} />
              </span>
            </a> */}
          {
            props.data.link_url == null || props.data.link_url == ''
              ? (
                <>
                  <div className="spotModuleLink">
                    <span className="spotModuleImage_w">
                      <img src={props.data.m_img_url}
                        className="spotModuleImg" alt={props.data.m_img_attr} />
                      {/* <Image
                    src={props.data.m_img_url}
                    className="spotModuleImg"
                    layout='fixed'
                    width={335}
                    height={256}
                    quality={props.data.imageQuality || 75}
                    alt={props.data.m_img_attr}
                  /> */}
                    </span>
                    <div className="spotProgramCont">
                      <strong className="spotProgram-Title">{props.data.title}</strong>
                    </div>
                  </div>
                </>
              )
              :
              (
                <>
                  <a href={props.data.link_url}>
                    <a onClick={(e) => handleClick(e, '3free')} target={props.data.link_new_yn === 'Y' ? '_blank' : ''} className="spotModuleLink">
                      <span className="spotModuleImage_w">
                        <img src={props.data.m_img_url}
                          className="spotModuleImg" alt={props.data.m_img_attr} />
                        {/* <Image
                    src={props.data.m_img_url}
                    className="spotModuleImg"
                    layout='fixed'
                    width={335}
                    height={256}
                    quality={props.data.imageQuality || 75}
                    alt={props.data.m_img_attr}
                  /> */}
                      </span>
                      <div className="spotProgramCont">
                        <strong className="spotProgram-Title">{props.data.title}</strong>
                      </div>
                    </a>
                  </a>
                </>
              )
          }
        </div>

      </div>
    </div >

  );
}
